// extracted by mini-css-extract-plugin
export default {"popup":"ABAActionPopup_popup__ghxQL","ellipsis":"ABAActionPopup_ellipsis__l0IdH"};